import gql from 'not-graphql-tag';
import {
  AccountDetailList,
  AccountDetailListParams,
  AccountStatusType,
  AccountType,
} from '../__generated__/pge-types';
import { VirtualAccountType } from '../constants/customEnum';
import useAuthQuery from './useAuthQuery';

export const getAccountTypes = gql`
  query getAccountTypes($params: AccountDetailListParams!) {
    getAccountDetailList(params: $params) {
      accounts {
        accountNumber
        accountType
      }
    }
  }
`;

const useHasNonResidentialAccounts = () => {
  const { data: accountsData, loading } = useAuthQuery<
    { getAccountDetailList: AccountDetailList },
    { params: AccountDetailListParams }
  >(getAccountTypes, {
    variables: {
      params: {
        groupId: VirtualAccountType.ALL_ACCTS,
        paging: undefined,
        accountStatus: AccountStatusType.Active,
      },
    },
  });

  return {
    loading,
    hasNonResidentialAccounts: Boolean(
      accountsData?.getAccountDetailList?.accounts?.some(
        account => account?.accountType !== AccountType.Res,
      ),
    ),
  };
};

export default useHasNonResidentialAccounts;
